"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ServerSideEncryptionRule_1 = require("./_ServerSideEncryptionRule");
exports._ServerSideEncryptionRules = {
    type: "list",
    flattened: true,
    member: {
        shape: _ServerSideEncryptionRule_1._ServerSideEncryptionRule
    }
};
//# sourceMappingURL=_ServerSideEncryptionRules.js.map